import Image from "next/image";
import { useTranslations } from "next-intl";

export function TrustedCompanies() {
  const t = useTranslations();

  const companies = [
    "hibbett",
    "flowers",
    "chinook",
    "billy-reid",
    "sneex",
    "turtleson",
  ];

  return (
    <div>
      <p className="text-white/70 text-sm mb-4">{t("signUp.trustedBy")}</p>
      <div className="grid grid-cols-3 gap-2">
        {companies.map((company: string) => (
          <div
            key={company}
            className="bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center border border-white/20 h-12"
          >
            <Image
              src={`/cms-logos/${company}.png`}
              alt={company}
              width={80}
              height={32}
              className="object-contain max-w-full max-h-full"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
